// extracted by mini-css-extract-plugin
module.exports = {"trainer":"TeamTrainer-module--trainer--13NYX"};